import { Box, Text } from '@zillow/constellation-10';
import MessageStatusIndicator, { type MessageStatusVariant } from './MessageStatusIndicator';
import MessageMetaLabel, { type MessageMetaLabelVariant } from './MessageMetaLabel';
import { Timestamp } from '../..';
import { FULLSTORY_EXCLUDE_CLASS_NAME } from '../../constants';

type MessageFooterProps = {
  failureText?: string;
  isMessageOwner: boolean;
  isSenderAnnouncedByBubble?: boolean;
  messageDateMs: string;
  metaLabelType?: MessageMetaLabelVariant;
  resendMessage?: () => void;
  senderName?: string;
  sendStatus?: MessageStatusVariant;
  shouldDisplaySentStatus?: boolean;
};

export default function MessageFooter({
  failureText,
  isMessageOwner,
  isSenderAnnouncedByBubble = false,
  messageDateMs,
  metaLabelType,
  resendMessage,
  senderName,
  sendStatus,
  shouldDisplaySentStatus,
}: MessageFooterProps): JSX.Element {
  const shouldShowStatusIndicator = !!sendStatus && isMessageOwner;
  const shouldShowSenderName = !isMessageOwner && !!senderName;

  return (
    <Box
      css={{
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        justifyContent: isMessageOwner ? 'flex-end' : 'flex-start',
      }}
    >
      {shouldShowStatusIndicator && (
        <MessageStatusIndicator
          failureText={failureText}
          shouldDisplaySentStatus={shouldDisplaySentStatus}
          status={sendStatus}
          resendMessage={resendMessage}
        />
      )}

      {shouldShowSenderName && (
        <Text
          aria-hidden={isSenderAnnouncedByBubble}
          className={FULLSTORY_EXCLUDE_CLASS_NAME}
          textStyle="body-xs"
          css={{ color: 'text.subtle', marginInlineEnd: 'tightest', textTransform: 'capitalize', textWrap: 'nowrap' }}
        >
          {messageDateMs ? `${senderName} ·` : senderName}
        </Text>
      )}

      {!!messageDateMs && <Timestamp messageDateMs={messageDateMs} />}

      {!!metaLabelType && <MessageMetaLabel metaLabelType={metaLabelType} />}
    </Box>
  );
}
